import Factory from '../utils/factory'

export default Factory({
  name: null,
  internalId: null,
  pricing: {
    value: null,
    type: 'fixed',
    margin: {
      value: null,
      type: 'fixed',
    },
    vat: null,
    rounding: 'none',
  },
  description: null,
  technicalDescription: null,
  supplier: null,
  tags: [],
  images: [],
  thumbnail: null,
  attachments: [],
  products: [],
  variants: null,
  reference: null,
  customFields: null,
})
